import { h, defineComponent, inject } from 'vue';
import { ImageAsset } from '@/ui/components/asset/ImageAsset';
import { ItemProps } from '@/ui/components/inspectionReport/types';
import { LegacyPhoto } from '@/ui/components/inspectionReport/legacyTypes';
import { useInspectionReport } from '@/ui/components/inspectionReport/useInspectioReport';
import { isLowQualityImagesFromReportPageKey } from '@/ui/injectionKeys';
import { isPdf } from '@/ui/helpers/systemHelper';
import { isAiImageDescriptionFeatureEnabled } from '@/ui/auth/auth';
import { isAiPackEnabled } from '@/ui/helpers/featureHelper';
import PhotoValidation from '@/ui/components/inspectionReport/items/PhotoValidation.vue';

export const Photo = defineComponent<ItemProps>({
  name: 'Photo',
  props: ['item'],
  setup(props) {
    return function render() {
      const isLowQualityImages = inject(isLowQualityImagesFromReportPageKey, false);
      let photoResponse = null;

      if (props.item.responded && props.item.response && Array.isArray(props.item.response)) {
        const photos = props.item.response as Array<LegacyPhoto>;

        photoResponse = photos.map(photo => {
          const showValidation = isAiPackEnabled()
            && props.item.params?.ai_image_validation_enabled
            && photo.validation;

          const showImageDescription = !showValidation
            && isAiImageDescriptionFeatureEnabled.value
            && props.item.params?.ai_image_description_enabled
            && photo.image_description;

          return h('div', { class: 'flex mb-2' }, [
            h('span', {
              class: ['mr-1', 'inspection-report__image-drawing-index'],
            }, [`${photo.index}.`]),
            h(ImageAsset, {
              class: 'mr-3 inline-block inspection-report__image-drawing-thumbnail',
              props: {
                photo,
                isLowQualityImages: isPdf && isLowQualityImages,
              },
            }),
            showValidation
              ? h(PhotoValidation, {
                props: {
                  validation: photo.validation,
                  criteria: props.item.params?.ai_image_validation_criteria,
                },
              })
              : null,
            showImageDescription
              ? h('span', [photo.image_description])
              : null,
          ]);
        });
      }

      const hasVerticalLayout = (isAiImageDescriptionFeatureEnabled.value
            && props.item.params?.ai_image_description_enabled)
            || (isAiPackEnabled() && props.item.params?.ai_image_validation_enabled);

      return h('div', {
        class: {
          'inspection-report__image-drawing-container': true,
          'inspection-report__image-drawing-container--vertical': hasVerticalLayout,
        },
      },
      props.item.responded ? photoResponse : useInspectionReport().getNotRespondedAnswer());
    };
  },
});
